<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'申请政策申报审核',goback:true},{name:'政策申报信息'}]" :title="'政策申报信息'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="基本信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">活动标题：</div>
                        <div class="content">{{dataInfo.activityTitle||'--'}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">活动类型：</div>
                        <div class="content">{{dataInfo.activityTypeValue||'--'}}</div>
                    </div>
                  </el-col>
                 
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">报名截止时间：</div>
                        <div class="content">{{dataInfo.registrationDeadline||'--'}}</div>
                    </div>
                    </el-col>
                 
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">活动开始时间：</div>
                        <div class="content">{{dataInfo.startDate||'--'}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">活动结束时间：</div>
                        <div class="content">{{dataInfo.endDate||'--'}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">活动举办地址：</div>
                        <div class="content">{{dataInfo.activityAddress||'--'}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">活动主办单位：</div>
                        <div class="content">{{dataInfo.activityOrganizer||'--'}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child" v-if="dataInfo.fitCrowd&&dataInfo.fitCrowd.length>0">
                        <div class="name">适用人群：</div>
                        <div class="content">
                    	<span v-for="(i,index) in dataInfo.fitCrowd" :key="index">
                    		{{i.value||'--'}}
                    	</span>
                    	</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">来源：</div>
                        <div class="content">{{dataInfo.source||'--'}}</div>
                    </div>
                  </el-col>
                 </el-row>
                 <el-row>
                  <el-col :span="24">
                      <div class="richText">
                        <div class="name">活动详情：</div>
                        <div class="content" v-html="dataInfo.activityDetails">{{dataInfo.activityDetails||'--'}}</div>
                    </div>
                  </el-col>
                  </el-row>
                 
                 <el-row>
                  <el-col :span="24">
                     <div class="attachment"  v-if="dataInfo.fileList&&dataInfo.fileList.length>0">
                        <div class="name">附件：</div>
                        <ul class="content">
                    		<li v-for="(i,index) in dataInfo.fileList" :key="index">
                    			<span>{{i.fileName}}</span>
                    			<i class="el-icon-download" @click="downLoad(i)"></i>
                    		</li>
                        </ul>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            dataInfo:{
                id: void 0,
                fileList:[]
            }
		
        }
    },
    methods:{
        //下载附件
        downLoad:function({fileName,filePath}){
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('/backstage/activity/salon/details/'+this.id)
          if (code == 200) {            
              this.dataInfo=data;
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>